import axios from 'axios'
import router from '../router'

export const API_ENDPOINT =
	process.env.NODE_ENV !== 'production'
		? 'http://localhost:5000/v2/backend'
		: 'https://v2.apimsn.com/v2/backend'

const instance = axios.create({
	baseURL: API_ENDPOINT,
})

instance.interceptors.request.use((config) => {
	const token = localStorage.getItem('x-backend-auth')
	const prefix = localStorage.getItem('x-prefix')

	return {
		...config,
		headers: {
			...config.headers,
			...(prefix && {
				'X-Prefix': prefix
			}),
			...(token && {
				Authorization: token
			}),
		},
	}
})
instance.interceptors.response.use(
	(response) => response.data,
	(err) => {
		if (err.response) {
			if (err.response.status === 401) {
				localStorage.removeItem('x-backend-auth')

				if (router.currentRoute.path !== '/login') {
					router.push('/login')
				}
			}
			return Promise.reject(err.response.data)
		}
		return Promise.reject({
			message: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ในขณะนี้',
		})
	}
)

export default instance